import { createAction } from 'redux-actions';
import { getManagedApplyList } from './service';
import STATUS_CODE from '../../../request/statusCode';
import { RESET, SET_LOADING, SET_MANAGED_APPLY } from './actionTypes';

const INITIAL_MANAGED_APPLY = [];
const reset = createAction(RESET);

const setManagedApply = createAction(SET_MANAGED_APPLY);

const setLoading = createAction(SET_LOADING);

const getManagedApply = () => {
  return dispatch => {
    dispatch(setLoading(true));
    getManagedApplyList().then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        return dispatch(setManagedApply(res.data));
      }
      return dispatch(setManagedApply(INITIAL_MANAGED_APPLY));
    });
  };
};

export {
  getManagedApply,
  setManagedApply,
  reset,
  setLoading,
  INITIAL_MANAGED_APPLY
};
